<template>
  <div id="cart-page" class="cart">
    <h1 class="boxTitle mb15 notranslate toUppercase">
      {{locale.cart}}
      <button v-if="isFloating" type="button" class="btnClose" @click.stop="close"></button>
    </h1>
    <CartList
      :lang="lang"
      :locale="locale"
      :isPublic="isPublic"
      :responsive="responsive"
      :isFloating="isFloating"
      @complete="completeShopOrder"
      @setToastMessage="setToastMessage"
      @closeCart="close" />
  </div>
</template>

<script>
import CartList from '@/components/Cart/CartList.vue'

export default {
  name: 'Cart',
  props: [
    'locale',
    'isPublic',
    'lang',
    'responsive'
  ],
  components: {
    CartList
  },
  computed: {
    isFloating () {
      return this.$route.name.includes('product') || this.$route.name.includes('shop')
    }
  },
  mounted () {
    // 기준 viewport 높이 저장
    this._vvhBase = window.visualViewport ? window.visualViewport.height : 0

    if (this.$route.name !== 'shop' && !this.$route.name.includes('product')) {
      this.track()
    }
    if (this.$route.name === 'shop' || (this.$route.name.includes('product') && this.responsive === 'tablet')) {
      document.body.classList.add('layerOn')
      setTimeout(() => {
        window.addEventListener('click', this.viewFloatingCart, true) // 캡처로 조금 더 안정적
        window.addEventListener('touchstart', this.viewFloatingCart, { passive: false })
        window.addEventListener('touchend', this.onTouchEnd, { passive: false })
        if (window.visualViewport) {
          window.visualViewport.addEventListener('resize', this.onVvResize) // iOS 키보드 감지용
        }
      }, 500)
    }
  },
  beforeDestroy () {
    document.body.classList.remove('layerOn')
    window.removeEventListener('click', this.viewFloatingCart, true)
    window.removeEventListener('touchstart', this.viewFloatingCart)
    window.removeEventListener('touchend', this.onTouchEnd)
    if (window.visualViewport) {
      window.visualViewport.removeEventListener('resize', this.onVvResize)
    }
  },
  data () {
    return {
      _vvhBase: 0,
      _ignoreScrollUntil: 0,
      _touchFromBackdrop: false,
    }
  },
  methods: {
    track () {
      const site = this.$store.state.authentication.site
      const routerPath = this.$route.path
      const path = `${site}${routerPath}`
      this.$gtag.pageview({
        page_path: path,
        page_title: 'cart'
      })
    },
    setToastMessage (message, dur) {
      this.$emit('setToastMessage', message, dur)
    },
    close (e) {
      this.$emit('close', e)
    },
    // 키보드 열림/닫힘 동안은 스크롤로 닫지 않기
    onVvResize () {
      // 키보드가 올라오면 height가 기준보다 작아짐
      const vv = window.visualViewport
      const keyboardOpen = this._vvhBase && vv && (vv.height < this._vvhBase - 40) // 여유 40px
      this._ignoreScrollUntil = keyboardOpen ? Date.now() + 2000 : Date.now() + 150 // 안정 버퍼
    },
    viewFloatingCart (e) {
      // 텍스트노드 대비 (nodeType 3)
      const tgt = e.target && e.target.nodeType === 1
        ? e.target
        : e.target && e.target.parentElement
      const path = typeof e.composedPath === 'function' ? e.composedPath() : []

      const cartEl = document.getElementById('cart-page')
      const floatingEl = document.getElementById('floatingCart')

      // 내부면 무시
      const insideCart =
        (tgt && tgt.closest && tgt.closest('#cart-page')) ||
        (path && path.some(el => el && el.id === 'cart-page'))
      if (insideCart) {
        // 내부에서 시작된 터치는 합성 클릭을 막기 위해 살짝 보정
        if (e.type === 'touchstart') {
          // 내부터치 직후 발생할 수 있는 scroll/click을 잠시 무시
          this._ignoreScrollUntil = Date.now() + 400
        }
        return
      }

      // 배경 안인지 확인
      const insideFloating =
        (tgt && tgt.closest && tgt.closest('#floatingCart')) ||
        (path && path.some(el => el && el.id === 'floatingCart'))
      if (!insideFloating) return

      // 배경 자체 탭(= .self)만 닫기
      const topMost = path && path.length ? path[0] : tgt
      const isBackdropSelfTap =
        (topMost === floatingEl) || (tgt === floatingEl) || (e.target === e.currentTarget)

      if (!isBackdropSelfTap) return

      // iOS 합성 클릭 억제: 배경 직접 탭이면 기본동작 막아 중복 트리거 방지
      if (e.type === 'touchstart') {
        e.preventDefault()
        this._ignoreScrollUntil = Date.now() + 400
      }
      e.stopPropagation()
      this.close(e)
    },

    onTouchEnd () {
      // 터치 끝난 직후 약간의 버퍼 동안 스크롤 닫기 무시
      this._ignoreScrollUntil = Math.max(this._ignoreScrollUntil, Date.now() + 200)
    },
    completeShopOrder (message) {
      this.$emit('complete', message)
    }
  }
}
</script>
